var map = {
	"./cla.png": 6824,
	"./dls.png": 5109,
	"./edr.png": 7749,
	"./elp.png": 1071,
	"./hls.png": 4745,
	"./ila.png": 4282,
	"./plc.png": 4513,
	"./sls.png": 2810,
	"./tlr.png": 1068,
	"./tls.png": 2693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8854;